<template>
  <Home v-if="authenticated"/>
  <Greeting v-else/>
</template>

<script>
import Home from './Home.vue'
import Greeting from './Greeting.vue'
import {mapGetters } from 'vuex'

export default {
  name: 'Main',
  components: {
    Home,
    Greeting
  },

  computed: {
    ...mapGetters({
     authenticated: 'auth/authenticated'
   })
  }
}
</script>
